var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('audio',{style:({'margin-bottom':'20px'}),attrs:{"controls":"","controlsList":"nodownload","src":_vm.audio.url,"type":"audio/mpeg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }